import React, { useState } from "react";
import { Outlet, useNavigate, useSearchParams } from "react-router-dom";

import { Opportunity } from "../types/crm";
import { OpportunityFormModal } from "./OpportunityFormModal";
import { Sidebar } from "./Sidebar";

export function AppShell() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [createOpen, setCreateOpen] = useState(false);

  const handleCreated = (opportunity: Opportunity) => {
    setCreateOpen(false);
    // Leva ao Kanban já no funil onde o card caiu, com ele visível.
    const slug = opportunity.pipeline_detail?.slug;
    navigate(`/pipeline${slug ? `?pipeline=${slug}` : ""}`, {
      state: { createdOpportunityId: opportunity.id, ts: Date.now() },
    });
  };

  return (
    <div className="flex min-h-screen">
      <Sidebar />
      <main className="flex flex-1 flex-col bg-primary-faint">
        <header className="flex items-center justify-end border-b border-border-soft bg-white/70 px-8 py-3 backdrop-blur">
          <button
            type="button"
            onClick={() => setCreateOpen(true)}
            className="rounded-[10px] bg-primary px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-primary-dark"
          >
            + Novo
          </button>
        </header>
        <div className="flex-1 overflow-y-auto">
          <Outlet />
        </div>
      </main>

      {createOpen && (
        <OpportunityFormModal
          initialPipelineSlug={searchParams.get("pipeline") ?? undefined}
          onClose={() => setCreateOpen(false)}
          onSaved={handleCreated}
        />
      )}
    </div>
  );
}
